import type { CSSProperties } from "react";
import type { Risk } from "./risk";
import { useAdminT } from "./useAdminT";

const BASE: CSSProperties = {
  display: "inline-block", padding: "2px 8px", borderRadius: 999,
  fontFamily: "var(--font-mono)", fontSize: 11, lineHeight: "16px",
  border: "1px solid var(--d-line)", background: "transparent",
  color: "var(--d-fg-muted)",
};

const STYLES: Record<Risk, CSSProperties> = {
  none: BASE,
  caution: { ...BASE, color: "var(--d-fg)", borderColor: "var(--d-fg-muted)" },
  danger: { ...BASE, color: "var(--d-ember)", borderColor: "var(--d-ember)" },
};

export function RiskBadge({ risk }: { risk: Risk }): JSX.Element {
  const t = useAdminT();
  return (
    <span data-testid="risk-badge" data-risk={risk} style={STYLES[risk]}>
      {t(`shell.risk.${risk}`)}
    </span>
  );
}
